import React, { useEffect, useState } from "react";
import Login from "./Login.jsx";
import Register from "./Register.jsx";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { removeCookies } from "../../services/Cookies.jsx";
import { setloggedIn } from "../../store/slices/userSlice.js";
import { useResponsive } from "../../hooks/useResponsive.js";

export default function AuthComponent() {
  const { isMobile } = useResponsive();
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("login");
  const dispatch = useDispatch();

  useEffect(() => {
    const tab = searchParams?.get("tab")?.trim();
    if (tab) {
      if ((tab != "login" && tab != "register") || tab == "undefined") {
        setActiveTab("login");
      }
      setActiveTab(tab);
    } else {
      setActiveTab("login");
    }
  }, [searchParams?.get("tab")]);

  useEffect(() => {
    dispatch(setloggedIn(false));
    removeCookies("token");
  }, []);

  return (
    <>
      {!isMobile ? (
        <div className="flex items-center justify-center min-h-screen bg-[#f9f9f9] auth-bg">
          <div className="w-full max-w-md bg-white p-10 rounded-2xl shadow-xl">
            <div className="flex justify-center mb-8">
              <img
                src="/assets/logo/logo.png"
                alt="logo"
                className="h-20 w-48 object-contain "
              />
            </div>
            <div className="mt-4">
              {activeTab === "login" ? <Login /> : <Register />}
            </div>
          </div>
        </div>
      ) : (
        <div className="bg-blue-50 h-svh mobile-dashboard">
          <div className="p-5 pt-10">
            <div className="flex justify-center mb-8">
              <img
                src="/assets/logo/logo.png"
                alt="logo"
                className="h-14 w-48 object-contain "
              />
            </div>
            {activeTab === "login" ? <Login /> : <Register />}
          </div>
        </div>
      )}
    </>
  );
}
